'use strict';

define('lib/analytics/config.local',[], function () {
  return function buildConfig(params) {
    var localConfigDefault = {
      oldGlobal: false,
      preventClicks: false, // prevents default event on OLD and NEW DL clicks
      debug: {
        contextAdd: false,
        contextGet: false,
        trigger: true, // console.table of pretty data "sent" or DummyFireTag from old DL
        blocks: false,
        logClicks: false // logs text 'click OLD' or 'click 1.5' so we can see which DL click came from
      }
    };

    if (params) {
      var vals = params.split(',');
      var newConfig = {};
      var newDebug = {};

      Object.keys(localConfigDefault).forEach(function (item) {
        if (vals.indexOf(item) > -1) {
          newConfig[item] = true;
        }
      });
      var config = Object.assign(localConfigDefault, newConfig);

      Object.keys(localConfigDefault.debug).forEach(function (item) {
        if (vals.indexOf(item) > -1) {
          newDebug[item] = true;
        }
      });
      var configDebug = Object.assign(localConfigDefault.debug, newDebug);

      return Object.assign(config, configDebug);
    }

    return localConfigDefault;
  };
});

